import React from 'react';
import ValuationTableWidgetRenderer from './ValuationTableWidgetRenderer';

const Preview: React.FC = () => (
  <ValuationTableWidgetRenderer config={{}} />
);

export default Preview;
